<div class="mat-dialog-container">
  <h1 mat-dialog-title>Confirmation</h1>
  <mat-dialog-content>
    <ng-container *ngIf="!(confirmationsLoading$ | async) && !(subServicesLoading$ | async); else spinner">
      <h6>
        Please select the service and sub-service type that you want to submit for payment. Alternatively you can search
        for the sub-service below.
      </h6>
      <div class="filter-tabs">
        <div class="filter-tabs-inner">
          <div class="filter-tab service-tab"
               (click)="displayServices()"
               [ngClass]="{'active-tab' : (serviceTabActive)}">
            <div class="filter-tab-inner" [ngSwitch]="serviceType">
              <div class="filter-icon" *ngSwitchCase="'imageService'">
                <svg-icon src="/assets/icons/jobs/camera.svg"></svg-icon>
                <span>Images</span>
              </div>
              <div class="filter-icon" *ngSwitchCase="'videoService'">
                <svg-icon src="/assets/icons/jobs/video.svg"></svg-icon>
                <span>Videos</span>
              </div>
              <div class="filter-icon" *ngSwitchCase="'floorplanService'">
                <svg-icon src="/assets/icons/jobs/floorplan.svg"></svg-icon>
                <span>Floor Plans</span>
              </div>
            </div>
          </div>
          <div class="filter-tab history-tab"
               [ngClass]="{'active-tab' : !serviceTabActive, 'confirmation-history-exists': confirmationsHistory.length > 0 && serviceTabActive}"
               (click)="displayHistory()">
            <div class="filter-icon">
              <svg-icon src="/assets/icons/jobs/service-history.svg"></svg-icon>
              <span>History</span>
            </div>
          </div>
        </div>
      </div>

      <ng-container #productsTemplate *ngIf="serviceTabActive; else history">
        <div class="filter-wrapper">
          <div class="form-field form-field-search">
            <mat-form-field id="jobs-toolbar-item" appearance="outline">
              <input
                id="search-input-bar"
                matInput
                #searchAddressInput
                placeholder="Search..."
              />
              <img src="/assets/icons/search.svg" alt="Search"/>
              <div *ngIf="false" class="search-helper-text">
                Please enter at least 2 characters
              </div>
            </mat-form-field>
          </div>
          <div class="service-priority-dropdown">
            <div class="form-field form-field-select">
              <mat-form-field appearance="outline">
                <mat-select [value]="priorityFilters[0]" (valueChange)="onServicePriorityFilterChange($event)"
                >
                  <mat-option *ngFor="let priority of priorityFilters; let i = index" [value]="priority">
                    {{ priority }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <ng-container *ngIf="filteredSubServices.length > 0; else placeholder">
          <div class="list-items">
            <div *ngFor="let item of filteredSubServices" class="list-item"
                 [ngClass]="{'sub-service-selected': item.selected}">
              <div class="sub-service-details">
                <div class="checkbox">
                  <mat-checkbox
                    class="temp-name"
                    [checked]="!!confirmation[item.id]"
                    (change)="subServiceChange(item, $event.checked)"
                  ></mat-checkbox>
                  <span>{{ item.itemName }}</span>
                </div>
                <div class="major-pill-container">
                  <div class="major-pill"
                       *ngIf="(selectedPriorityFilter === priorityFilters[0]) && (item.priority === priorityFilters[1].toLowerCase())">
                    <span>Major</span>
                  </div>
                </div>
                <div class="purchases-price-text" *ngIf="item.purchasesUnitPrice">
                  <span>{{ item.purchasesUnitPrice }}</span>
                </div>
              </div>

              <div *ngIf="!!confirmation[item.id]" class="service-counter-wrapper">
                <button class="btn-counter" mat-icon-button (click)="decreaseSubServiceCount(item.id)">
                  <svg-icon src="/assets/icons/jobs/remove.svg"></svg-icon>
                </button>
                <div class="counter-wrapper">
                  <div class="sub-service-counter"
                       disabled
                       type="text"
                  >
                    {{ (confirmation[item?.id]) ? confirmation[item?.id]['itemCount'] : '1' }}
                  </div>
                </div>
                <button class="btn-counter" mat-icon-button (click)="increaseSubServiceCount(item.id)">
                  <svg-icon src="/assets/icons/jobs/add.svg"></svg-icon>
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="invoiceConfirmationTotal !== null" [ngClass]="invoiceConfirmationTotal > 0 ? 'confirmation-total-wrapper positive-total-border' : 'confirmation-total-wrapper'">
            <span>Total amount due</span>
            <div class="total-text">
              {{ invoiceConfirmationTotal | number : '1.2-2' }}
            </div>
          </div>
        </ng-container>
        <ng-template  *ngIf="filteredSubServices?.length === 0" #placeholder>
          <div class="product-list-empty">
            <span>No products available...</span>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #history>
        <div class="list-items">
          <div *ngFor="let confirmation of confirmationsHistory" class="confirmation-item">
            <div class="confirmation-item-info">
              <div class="confirmation-text">
                <span class="full-name-text">{{ confirmation.processorName }}&nbsp;</span>
                <span> requested payment for:</span>
              </div>
              <span class="created-text">{{ confirmation.created }}</span>
            </div>
            <div class="pill-list">
              <div class="sub-service-pill" *ngFor="let subService of confirmation.confirmations">
                <span class="sub-service-text">
                  {{ subService.itemQuantity + 'x ' + subService.subServiceType + ' (' + (subService.itemTotal | number : '1.2-2') + ')'}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="invoiceHistoryTotal !== null" [ngClass]="invoiceHistoryTotal > 0 ? 'confirmation-total-wrapper positive-total-border' : 'confirmation-total-wrapper'">
          <span>Total amount due</span>
          <div class="total-text">
            {{ invoiceHistoryTotal | number : '1.2-2' }}
          </div>
        </div>
      </ng-template>

    </ng-container>
    <ng-template #spinner>
      <div class="loading-spinner">
        <mat-progress-spinner mode="indeterminate" color="accent" [diameter]="100"
                              [strokeWidth]="5"></mat-progress-spinner>
      </div>
    </ng-template>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="btn btn-red cancel-btn" mat-button (click)="closeDialog()">Cancel</button>
    <button [disabled]="postingConfirmation || !confirmationChanged" class="btn btn-green" mat-raised-button
            (click)="confirmJob()">
      Confirm
      <ng-template [ngIf]="postingConfirmation">
        <div class="lds-hourglass"></div>
      </ng-template>
    </button>
  </mat-dialog-actions>

</div>
